import device from '../helpers/device'
import refs from '../helpers/refs'
import smoothScroll from '../helpers/smoothScroll'
import videoUtil from '../helpers/video'

class CMastheadUnitedByFlavor {
  constructor (el) {
    this.$root = el
    this.$refs = refs(this.$root)
    // By default background videos are paused, if `backgroundVideoPaused` is not set, then the video will start playing
    this.videoPaused = true

    this.init()
  }

  init () {
    // Different video sources for different screen sizes
    // Convert video data attributes to video sources
    if (this.$refs.backgroundVideo) {
      videoUtil.setVideoSources(this.$refs.backgroundVideo)
      this.initPauseVideoButton()
    }

    if (this.$refs.scrollDown) {
      this.$refs.scrollDown.addEventListener('click', (e) => {
        smoothScroll(this.hero, false, -100)
      })
    }

    // Set hero to full height on mobile screens
    if (device.isMobile()) {
      this.hero.style.height = window.innerHeight + 'px'
    }
  }

  initPauseVideoButton () {
    if (this.$refs.playPauseVideoButton) {
      this.$refs.playPauseVideoButton.addEventListener('click', (e) => {
        e.preventDefault()

        if (this.videoPaused) {
          this.$refs.backgroundVideo.play()
          this.videoPaused = false
          this.$refs.pauseIcon.classList.remove('hidden')
          this.$refs.playIcon.classList.add('hidden')

          // In local storage, keep track of when a video gets paused
          localStorage.setItem('backgroundVideoPaused', 'false')
        } else {
          this.$refs.backgroundVideo.pause()
          this.videoPaused = true
          this.$refs.pauseIcon.classList.add('hidden')
          this.$refs.playIcon.classList.remove('hidden')

          // In local storage, keep track of when a video gets paused
          localStorage.setItem('backgroundVideoPaused', 'true')
        }
      })

      // Check if the video was paused in localStorage or user has set prefers reduced motion, if so, have it start paused
      const isReduced = window.matchMedia('(prefers-reduced-motion: reduce)') === true || window.matchMedia('(prefers-reduced-motion: reduce)').matches === true
      const videoPaused = localStorage.getItem('backgroundVideoPaused') === 'true' || isReduced

      if (!videoPaused) {
        // By default background videos will start paused
        // If `backgroundVideoPaused` is not set, then the video will start playing
        this.$refs.backgroundVideo.play()
        this.videoPaused = false
        this.$refs.pauseIcon.classList.remove('hidden')
        this.$refs.playIcon.classList.add('hidden')
      }
    }
  }
}

window.addEventListener('load', () => {
  document
    .querySelectorAll('.c-masthead-united-by-flavor')
    .forEach(el => new CMastheadUnitedByFlavor(el))
})
